jQuery(function ($) {
    if ($(location).attr('href').indexOf('#news-index-block') > 0) {
        $('html, body').animate({
            scrollTop: $("#news-index-block").offset().top
        }, 1000);
    }
});